module.exports = __webpack_public_path__ + "img/yaxun-sports-logo.eb1f3126.svg";